import React from 'react';
import { Form, Checkbox, CheckboxProps, FormItemProps } from 'antd';
import { useTrans } from 'base/utils/i18n';

type FormRegisterAgreeProps = FormItemProps & {
    name?: string;
    rules?: FormItemProps['rules'];
    inputProps?: CheckboxProps;
};

const FormRegisterAgree: React.FC<FormRegisterAgreeProps> = props => {
    const { t } = useTrans();
    const {
        name = 'agreement',
        label,
        rules = [
            {
                validator: (_, value) =>
                    value
                        ? Promise.resolve()
                        : Promise.reject(new Error(t('web_form_agree_error'))),
            },
        ],
        inputProps = {},
        ...rest
    } = props;

    return (
        <Form.Item
            name={name}
            rules={rules}
            valuePropName="checked"
            {...rest}
        >
            <Checkbox className={'g-agree'} {...inputProps}>
                {label}
            </Checkbox>
        </Form.Item>
    )
};

export default FormRegisterAgree;